module.exports = __webpack_public_path__ + "catalog/items/deskoffice/wood.jpg";